import * as x from "react";
import { i as c, b as h, E as v, x as p, a as b, r as f, c as _ } from "../createReactComponent-58f9bea8.mjs";
import { n as d } from "../property-9daa16cd.mjs";
import { e as n } from "../class-map-2994e95e.mjs";
import { S as g } from "../slot-controller-fa97ce97.mjs";
import { r as y } from "../icon-button-a9d2a2d1.mjs";
import "../icon-c572aa57.mjs";
import "../tooltip-cb602d1f.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
var u = Object.defineProperty, T = Object.getOwnPropertyDescriptor, m = (t, a, r, o) => {
  for (var s, e = o > 1 ? void 0 : o ? T(a, r) : a, l = t.length - 1; l >= 0; l--)
    (s = t[l]) && (e = (o ? s(a, r, e) : s(e)) || e);
  return o && e && u(a, r, e), e;
};
class i extends v {
  constructor() {
    super(...arguments), this.pageTitle = "Page Header", this.infoText = "", this.slotController = new g(this, "buttons"), this.titleController = new g(this, "title");
  }
  getInfoText() {
    return this.infoText ? p`
        <ex-icon-button
          icon="information"
          flavor="branded"
          hide-browser-tooltip=""
          type="tertiary"
          tooltipText=${this.infoText}
          size="x-small"
          circular=""
        ></ex-icon-button>
      ` : b;
  }
  render() {
    const a = { "page-header__buttons": !0, nomargin: !this.slotController.test("buttons") }, r = { "page-header__body": !0, nomargin: !this.slotController.test("body") }, o = { "page-header__tabs": !0, nomargin: !this.slotController.test("tabs") }, s = { "page-header__title": this.pageTitle || this.titleController.test("title") };
    return p`
      <div class="page-header__breadcrumbs">
        <slot name="breadcrumbs"></slot>
      </div>
      <div class="page-header__alert-banner">
        <slot name="alert-banner"></slot>
      </div>
      <div class="page-header">
        <div class="${n(s)}">
          <slot name="title">${this.pageTitle}</slot>
          ${this.getInfoText()}
        </div>
        
        <div class="page-header__badge">
          <slot name="badge"></slot>
        </div>
        </div>
        <div part="page-header-body">
          <div class=${n(r)}>
            <slot name="body"></slot>
          </div>
          <div class=${n(a)}>
            <slot name="buttons"></slot>
          </div>
          <div class=${n(o)} aria-label="${this.pageTitle}">
            <slot name="tabs"></slot>
          </div>
        </div>
      </div>
    `;
  }
}
i.styles = c`
    ${h(`:host .page-header{display:flex;padding:var(--exo-spacing-x-small) var(--exo-spacing-none);align-items:center;align-content:center;gap:8px var(--exo-spacing-x-small);flex-wrap:wrap}:host .page-header__title{color:var(--exo-color-font);font-family:var(--exo-font-brand);font-size:24px;font-style:normal;font-weight:700;display:flex;gap:4px;align-items:center;align-content:center;height:30px}:host .page-header__body{font:var(--exo-text-body-medium);color:var(--exo-color-font-secondary);padding:var(--exo-spacing-x-small) var(--exo-spacing-none)}:host .page-header__buttons{display:flex;flex-wrap:nowrap;padding:var(--exo-spacing-x-small) var(--exo-spacing-none);gap:var(--exo-spacing-x-small)}:host .page-header__tabs{padding-top:var(--exo-spacing-x-small)}:host .nomargin{margin:var(--exo-spacing-none);padding:var(--exo-spacing-none)}
`)}
  `, m([d({ type: String })], i.prototype, "pageTitle", 2), m([d({ attribute: "info-text" })], i.prototype, "infoText", 2);
const w = (t = "") => {
  f("ex-page-header", i, t), y(t);
}, N = _({ tagName: "ex-page-header", elementClass: i, react: x, events: {}, displayName: "ExPageHeader", registerWebComponent: w });
export {
  N as ExPageHeader,
  w as register
};
